export const auth = {
  Login: "로그인",
  Logout: "로그아웃",
  Register: "회원가입",
  ChangeUserInfo: "사용자 정보 변경",
} as const;
